var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.loading)?_c('div',{staticClass:"text-no-data"},[_vm._v(_vm._s(_vm.emptyText))]):_vm._e(),(_vm.loading)?_c('loading-spinner',{attrs:{"text":_vm.loadingText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }